<template>
  <div class="q-nps-tigo-container main-color">
    <label v-html="question.q" class="q-label"></label>
    <div style="width:100%;">
      <label class="nps_label">{{question.begin_text}}</label>
      <label class="nps_label" style="text-align:right;">{{question.end_text}}</label>
    </div>
    <div style="width:100%; display:flex; flex-direction:row;">
      <label ref="options" v-for="option in question.answers" :key="option.value" :value="option.value" class="label_nps_tigo" style="width:100%;" v-on:click="selectNPS">{{ option.value }}</label>
    </div>
  </div>
</template>

<script>
export default {
  name: "nps-tigo-question",
  props: {
    question: {
      type: Object,
      default: () => {
        return {};
      }
    },
    answerProp:{
      type: String,
      default: ""
    }
  },
  data: function() {
    return {
      answer: ""
    };
  },
  computed: {
    myComputedWidth() {
      return Math.round(100 / ((this.question.max - this.question.min)+1));
    }
  },
  methods: {
    selectNPS: function(event) {
      //put to all elements the same class
      this.formatNPSInitial();

      //set the selected document
      event.target.classList.remove("label_nps_1");
      event.target.classList.remove("label_nps_2");
      event.target.classList.remove("label_nps_3");
      event.target.classList.add("label_nps_selected");
      this.answer = event.target.innerText;
      //console.log(event.target.innerText);
      //console.log(event.target);
      //console.log("La respuesta es: " + this.answer);
      this.$emit("emit-value", { "q_id": this.question.q_id, "q_type": this.question.q_type, "ans": this.answer });
    },
    formatNPSInitial: function() {
      var x = this.$refs.options;
      //var x = document.getElementsByClassName("label_nps_tigo");
      for (var i = x.length - 1; i >= 0; i--) {
        if (i > 8) {
          x[i].className = "label_nps_1";
        } else if (i > 6) {
          x[i].className = "label_nps_2";
        } else {
          x[i].className = "label_nps_3";
        }
      }
    },
    selectNPSValue: function(value) {
     
      //put to all elements the same class
      var x = this.$refs.options;//document.getElementsByClassName("label_nps_selected");
      this.formatNPSInitial();
      for (var i = 0; i < x.length; i++) {
        if(x[i].innerText === value){
          x[i].className = "label_nps_selected";
        }
        
      }
    }
  },
  mounted: function() {
    this.formatNPSInitial();
    if(this.answerProp != ""){
      this.selectNPSValue(this.answerProp);
    }
  }
};
</script>

<style lang="scss" scoped>
  .label_nps_tigo{
    text-align: center;
    float: left;
    color: #fff;
    font-size: 0.9em;
    height: auto;
    border: 1px solid #1d5073;
    margin: 0;
    /* padding: 10px; */
    padding-top:10px;
    padding-right:4px;
    padding-bottom:10px;
    padding-left:4px;
    -moz-border-radius: 5px;
    /* -webkit-border-radius: 5px; */
    /* border-radius: 5px; */
    background: rgba(6, 7, 32, 0.8);
}

.nps_label{
    font-size: small;
    color: #b1b1b1;
    font-style: italic;
    margin:0px;
    display: inline-block;
    padding: 0;
    width: 50%;
}

.label_nps_selected{
       text-align: center;
    float: left;
    color: #fff;
    font-size: 0.9em;
    height: auto;
    border: 1px solid #1d5073;
    margin: 0;
    /* padding: 10px; */
    padding-top:10px;
    padding-right:4px;
    padding-bottom:10px;
    padding-left:4px;
    -moz-border-radius: 5px;
    /* -webkit-border-radius: 5px; */
    /* border-radius: 5px; */
    background: rgba(162, 162, 162, 0.8);
}

.label_nps_1{
       text-align: center;
    float: left;
    font-size: 0.9em;
    height: auto;
    margin: 0;
    padding-top:10px;
    padding-right:4px;
    padding-bottom:10px;
    padding-left:4px;
    -moz-border-radius: 5px;
}


.label_nps_2{
       text-align: center;
    float: left;
    font-size: 0.9em;
    height: auto;
    margin: 0;
    padding-top:10px;
    padding-right:4px;
    padding-bottom:10px;
    padding-left:4px;
    -moz-border-radius: 5px;
}

.label_nps_3{
       text-align: center;
    float: left;
    font-size: 0.9em;
    height: auto;
    margin: 0;
    padding-top:10px;
    padding-right:4px;
    padding-bottom:10px;
    padding-left:4px;
    -moz-border-radius: 5px;
}
</style>
